// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"CompanyOpportunitiesPage_pageWrapper__2ApKx"};